"use client";

import Image from "next/image";
import PrimaryBtn from "@/components/PrimaryBtn";

import { Icons, Images } from "@assets/assets";
import { StaticImageData } from "next/image";
import DOMPurify from "isomorphic-dompurify";

export interface AuthorCardProps {
  authorName: string | undefined;
  authorImage: string | StaticImageData | undefined;
  authorDesc?: string | undefined | TrustedHTML;
}

export default function AuthorCard({
  authorName,
  authorImage,
  authorDesc,
}: AuthorCardProps) {
  return (
    <div className="w-full bg-white border border-[#ecf0f6] p-[30px] flex flex-col lg:flex-row lg:items-center gap-[30px] min-h-[340px]">
      {/* Left: Author image */}

      <Image
        src={authorImage ? authorImage : ""}
        alt="Author picture"
        width={280}
        height={280}
        className="object-cover w-[280px] h-[280px]"
        priority
        sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
        fetchPriority="high"
      />

      {/* Right: Content */}
      <div className="flex-1 flex flex-col gap-[30px]">
        <div className="flex flex-col gap-[15px]">
          <h3 className="text-[#00040b] text-[36px] leading-[1.2] clash-font font-medium m-0">
            {authorName}
          </h3>
        </div>

        <p
          className="text-[#636364] italic text-[18px] leading-[1.6] font-['Albert_Sans:Italic',_sans-serif] m-0"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(String(authorDesc ?? "")),
          }}
        />

        <div>
          <PrimaryBtn
            dark={false}
            iconSrc={Icons?.chevron}
            text={
              <span className="inline-flex items-center gap-[14px]">
                <span>Follow on LinkedIn</span>
                <Image
                  src={Images?.blogDetails.linkidin}
                  alt="LinkedIn"
                  width={20}
                  height={20}
                  priority
                  fetchPriority="high"
                />
              </span>
            }
          />
        </div>
      </div>
    </div>
  );
}
